<script setup lang="ts">
import type { EstimatedShippingRange } from "mws-ts-v2-sdk";

const { estimatedShippingRange } = defineProps<{
  estimatedShippingRange: EstimatedShippingRange | null;
  isFrame: boolean;
}>();
// estimated delivery dates
const estimatedDeliveryDateFirst = computed(
  () => estimatedShippingRange?.startDate,
);
const estimatedDeliveryDateLast = computed(
  () => estimatedShippingRange?.endDate,
);
const { localizedDateTime: localizedEstimatedDeliveryDateFirst } =
  useLocalizedDateTime(estimatedDeliveryDateFirst, "date");

const { localizedDateTime: localizedEstimatedDeliveryDateLast } =
  useLocalizedDateTime(estimatedDeliveryDateLast, "date");

const estimatedDelivery = computed(() => {
  if (
    !localizedEstimatedDeliveryDateFirst?.value ||
    !localizedEstimatedDeliveryDateLast?.value
  ) {
    return undefined;
  }

  return `${localizedEstimatedDeliveryDateFirst.value} - ${localizedEstimatedDeliveryDateLast.value}`;
});
</script>

<template>
  <div
    v-if="estimatedDelivery"
    data-test="estimated-delivery"
  >
    <I18nT
      keypath="product.description.shippingDetails.estimatedDelivery"
      tag="span"
      scope="global"
    >
      <template #PLACEHOLDER_date>
        <strong>{{ estimatedDelivery }}</strong>
      </template>
    </I18nT>
    <BaseTooltip class="ml-2">
      <p>
        {{
          $t("product.description.shippingDetails.estimatedDeliveryTooltip", {
            PLACEHOLDER_daysFrom: isFrame ? "10" : "2",
            PLACEHOLDER_daysTo: isFrame ? "12" : "4",
          })
        }}
      </p>
    </BaseTooltip>
  </div>
</template>
